import { render } from "./EuropeBankList.vue?vue&type=template&id=a5636ae8"
import script from "./EuropeBankList.vue?vue&type=script&lang=js"
export * from "./EuropeBankList.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__